export { default as exitMenu } from "./exitMenu";
